
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import ConnectionPracticeNotes from '@/components/ConnectionPracticeNotes.vue';

@Component({
  components: {
    ConnectionPracticeNotes,
  },
})
export default class PracticeNotesDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  onClose() {
    this.dialog = false;
  }
}
